import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as R from "ramda";
import { EducationInstitutionDetails } from "./educationInstitutionDetails";
import { ConnectionTypes } from "../../../../../constants/utils/connectionTypes";

export const EducationInstitution = ({ generateRelocationLetters }) => {
	const [educationInstitutionState, setEducationInstitutionState] = useState({
		items: [],
	});
	const services = useSelector((state) => state.services);
	const user = useSelector((state) => state.user);

	const educationInstitutionVector = services.serviceData["Etudiant"];
	useEffect(() => {
		let educationInstitutionsInState = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[ConnectionTypes.etudiant]) ? services.serviceData[ConnectionTypes.etudiant] : [];
		if (educationInstitutionsInState.length > 0) {
			setEducationInstitutionState({
				items: educationInstitutionsInState,
			});
		} else {
			setEducationInstitutionState({ ...educationInstitutionState, items: [{}] });
		}
	}, [services, services.serviceData, educationInstitutionVector]);

	function removeEducationInstitution(educationInstitution) {
		setEducationInstitutionState({ ...educationInstitutionState, items: educationInstitutionState.items.filter((ei) => ei !== educationInstitution) });
	}

	return (
		<article className="block" id="activité">
			<h3 className="sr-only visually-hidden">Établissement d'enseignement</h3>
			{educationInstitutionState.items.map((educationInstitution, index) => {
				return <EducationInstitutionDetails key={index} index={index} user={user} educationInstitution={educationInstitution} removeEducationInstitution={removeEducationInstitution} generateRelocationLetters={generateRelocationLetters} />;
			})}

			<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
				<h4 className="sr-only visually-hidden">Ajouter un autre ÉTABLISSEMENT D'ENSEIGNEMENT</h4>
				<button
					type="button"
					className="btn btn-icon btn-alert-info mx-auto py-2"
					onClick={(e) => {
						const nodes = window.document.querySelectorAll(".collapse.show");
						if (!R.isNil(nodes) && nodes.length > 0) {
							nodes.forEach((element) => {
								element.classList.remove(["show"]);
							});
						}
						setEducationInstitutionState({ ...educationInstitutionState, items: educationInstitutionState.items.concat({}) });
					}}>
					<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre ÉTABLISSEMENT D'ENSEIGNEMENT
				</button>
			</footer>
		</article>
	);
};
